var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_564_620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.49994 30.0716C2.49994 31.1323 3.3678 32.0001 4.42852 32.0001H27.5715C28.6322 32.0001 29.5001 31.1323 29.5001 30.0716C29.5001 29.0108 28.6322 28.143 27.5715 28.143H4.42852C3.3678 28.143 2.49994 29.0108 2.49994 30.0716Z",
    fill: "#002466"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 -0.000488281C16.2399 -0.000488281 16.4733 0.0528468 16.6999 0.159513C16.9266 0.26618 17.1199 0.42618 17.2799 0.639513L25.1999 10.7995C25.5999 11.3328 25.6533 11.8995 25.3599 12.4995C25.0666 13.0995 24.5866 13.3995 23.9199 13.3995H20.7999V22.9995C20.7999 23.4528 20.6466 23.8328 20.3399 24.1395C20.0333 24.4462 19.6533 24.5995 19.1999 24.5995H12.7999C12.3466 24.5995 11.9666 24.4462 11.6599 24.1395C11.3533 23.8328 11.1999 23.4528 11.1999 22.9995V13.3995H8.07993C7.41326 13.3995 6.93326 13.0995 6.63993 12.4995C6.34659 11.8995 6.39992 11.3328 6.79992 10.7995L14.7199 0.639513C14.8799 0.42618 15.0733 0.26618 15.2999 0.159513C15.5266 0.0528468 15.7599 -0.000488281 15.9999 -0.000488281Z",
    fill: "#002466"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_564_620"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.13685b370ffd9ae23644ae0a782e1aad.svg";
export { ForwardRef as ReactComponent };